import { tryCallApi } from 'common/helpers'
import { FixedAssetsService } from 'common/open-api'
import { getAxiosSilent } from 'common/open-api/helper'
import { handleErrorResponse } from 'common/utils/response-helper'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { parseCancelAcceleratedError } from '../helpers/parse-cancel-accelerated-error'
import { Cancel_Accelerated_Depreciation_Error } from '../types'

export const useValidateCancelAccelerated = (
  ledgerSettingId: number,
  setCanCancel: (canCancel: boolean) => void,
  setError?: (error: Cancel_Accelerated_Depreciation_Error) => void
) => {
  const { biid } = useParams<{ biid: string }>()
  const [isValidatingCancel, setIsValidatingCancel] = useState(false)

  const validateCancelAccelerated = async () => {
    setIsValidatingCancel(true)
    const response = await tryCallApi(FixedAssetsService.depreciationResultsValidateCancelAdjustCreate)(
      biid,
      { ledger_setting_id: ledgerSettingId },
      getAxiosSilent()
    )
    if (response.data) {
      setCanCancel(true)
    }
    if (response.error) {
      const parsedError = parseCancelAcceleratedError(response.error)
      if (!parsedError.isKnownError) {
        handleErrorResponse(response.error, undefined, { showToast: true })
      } else {
        setError?.(parsedError)
      }
    }
    setIsValidatingCancel(false)
  }

  return {
    isValidatingCancel,
    validateCancelAccelerated,
  }
}
